import { TransactionDetail } from "../../models/TransactionDetail";
import { TransactionType } from "../../models/enums";

export enum TxLabels {
  AMOUNT = "Amount",
  TYPE = "Type",
  BLOCK = "Block",
  TIMESTAMP = "Timestamp",
  FEE_PERCENTAGE = "Fee percentage",
  FEE = "Fee",
  TX_ID = "Transaction ID",
  INPUT_OUTPUT = "Inputs/Outputs",
  FROM = "Sent from",
  TO = "Sent to",
  NODE_ID = "Validator Node ID",
  WEIGHT = "Initial Stake",
  STAKE = "Stake amount",
  START_TIME = "Start date",
  END_TIME = "End date",
  DURATION = "Duration",
  DAYS_REMAINING = "Days remaining",
}

export enum TxInfo {
  AMOUNT = "Amount",
  STAKED_AMOUNT_VALIDATOR = "Total amount of staked FLR to Validator",
  AMOUNT_IMPORT_TX = "Amount of imported FLR to p-chain",
  AMOUNT_EXPORT_TX = "Amount of exported FLR to c-chain",
  CCHAIN_AMOUNT_IMPORT_TX = "Amount of imported FLR to c-chain",
  CCHAIN_AMOUNT_EXPORT_TX = "Amount of exported FLR to p-chain",
  AMOUNT_REWARD_TX = "Reward amount",
  TYPE = "Transaction Type",
  FEE_PERCENTAGE = "Percentage of rewards collected by validator",
  FEE = "Transaction fee",
  BLOCK = "Block Height",
  TIMESTAMP = "Date & Time of transaction inculsion",
  TX_ID = "Transaction ID",
  INPUT_OUTPUT = "List of inputs and outputs",
  FROM = "Address sending the transaction",
  TO = "Address receiving the transaction",
  NODE_ID = "Validator Node ID",
  WEIGHT = "Total amount of staked FLR (Known as Self bond)",
  START_TIME_VALIDATOR = "Start date of validator",
  END_TIME_VALIDATOR = "End date of validator",
  START_TIME_DELEGATOR = "Start date of staking",
  END_TIME_DELEGATOR = "End date of staking",
  DURATION = "Duration of delegation",
  DAYS_REMAINING = "Remaining days of delegation",
}

export enum TxKeys {
  AMOUNT = "outputs[0].amount",
  CCHAIN_AMOUNT_EXPORT_TX = "cChainAmountExportTx",
  CCHAIN_AMOUNT_IMPORT_TX = "cChainAmountImportTx",
  TYPE = "type",
  BLOCK = "blockHeight",
  TIMESTAMP = "chainTime",
  FEE_PERCENTAGE = "feePercentage",
  FEE = "fee",
  TX_ID = "txID",
  INPUT_OUTPUT = "outputs",
  FROM = "inputs[0].address",
  TO = "outputs[0].address",
  NODE_ID = "nodeID",
  WEIGHT = "weight",
  START_TIME = "startTime",
  END_TIME = "endTime",
  DURATION = "duration",
  DAYS_REMAINING = "daysRemaining",
}

export const txDefault: TransactionDetail[] = [
  { label: TxLabels.TX_ID, key: TxKeys.TX_ID, info: TxInfo.TX_ID },
  { label: TxLabels.TYPE, key: TxKeys.TYPE, info: TxInfo.TYPE },
  { label: TxLabels.BLOCK, key: TxKeys.BLOCK, info: TxInfo.BLOCK },
  { label: TxLabels.TIMESTAMP, key: TxKeys.TIMESTAMP, info: TxInfo.TIMESTAMP },
];

export const txTypeDelegator: TransactionDetail[] = [
  ...txDefault,
  { label: TxLabels.FROM, key: TxKeys.FROM, info: TxInfo.FROM },
  { label: TxLabels.TO, key: TxKeys.TO, info: TxInfo.TO },
  { label: TxLabels.NODE_ID, key: TxKeys.NODE_ID, info: TxInfo.NODE_ID },
  {
    label: TxLabels.STAKE,
    key: TxKeys.WEIGHT,
    info: TxInfo.STAKED_AMOUNT_VALIDATOR,
  },
  { label: TxLabels.FEE, key: TxKeys.FEE, info: TxInfo.FEE },
  {
    label: TxLabels.START_TIME,
    key: TxKeys.START_TIME,
    info: TxInfo.START_TIME_DELEGATOR,
  },
  {
    label: TxLabels.END_TIME,
    key: TxKeys.END_TIME,
    info: TxInfo.END_TIME_DELEGATOR,
  },
  {
    label: TxLabels.DURATION,
    key: TxKeys.DURATION,
    info: TxInfo.DURATION,
  },
  {
    label: TxLabels.DAYS_REMAINING,
    key: TxKeys.DAYS_REMAINING,
    info: TxInfo.DAYS_REMAINING,
  },
  {
    label: TxLabels.INPUT_OUTPUT,
    key: TxKeys.INPUT_OUTPUT,
    info: TxInfo.INPUT_OUTPUT,
  },
];

export const txTypeValidator: TransactionDetail[] = [
  ...txDefault,

  { label: TxLabels.FROM, key: TxKeys.FROM, info: TxInfo.FROM },
  { label: TxLabels.TO, key: TxKeys.TO, info: TxInfo.TO },
  { label: TxLabels.NODE_ID, key: TxKeys.NODE_ID, info: TxInfo.NODE_ID },
  { label: TxLabels.WEIGHT, key: TxKeys.WEIGHT, info: TxInfo.WEIGHT },
  { label: TxLabels.FEE, key: TxKeys.FEE, info: TxInfo.FEE },
  {
    label: TxLabels.FEE_PERCENTAGE,
    key: TxKeys.FEE_PERCENTAGE,
    info: TxInfo.FEE_PERCENTAGE,
  },
  {
    label: TxLabels.START_TIME,
    key: TxKeys.START_TIME,
    info: TxInfo.START_TIME_VALIDATOR,
  },
  {
    label: TxLabels.END_TIME,
    key: TxKeys.END_TIME,
    info: TxInfo.END_TIME_VALIDATOR,
  },
  { label: TxLabels.DURATION, key: TxKeys.DURATION, info: TxInfo.DURATION },
  {
    label: TxLabels.DAYS_REMAINING,
    key: TxKeys.DAYS_REMAINING,
    info: TxInfo.DAYS_REMAINING,
  },
  {
    label: TxLabels.INPUT_OUTPUT,
    key: TxKeys.INPUT_OUTPUT,
    info: TxInfo.INPUT_OUTPUT,
  },
];

export const txTypeImport: TransactionDetail[] = [
  ...txDefault,
  { label: TxLabels.AMOUNT, key: TxKeys.AMOUNT, info: TxInfo.AMOUNT_IMPORT_TX },
  { label: TxLabels.FEE, key: TxKeys.FEE, info: TxInfo.FEE },
  { label: TxLabels.TO, key: TxKeys.TO, info: TxInfo.TO },
  {
    label: TxLabels.INPUT_OUTPUT,
    key: TxKeys.INPUT_OUTPUT,
    info: TxInfo.INPUT_OUTPUT,
  },
];

export const txTypeExport: TransactionDetail[] = [
  ...txDefault,
  { label: TxLabels.AMOUNT, key: TxKeys.AMOUNT, info: TxInfo.AMOUNT_EXPORT_TX },
  { label: TxLabels.FEE, key: TxKeys.FEE, info: TxInfo.FEE },
  { label: TxLabels.FROM, key: TxKeys.FROM, info: TxInfo.FROM },
  { label: TxLabels.TO, key: TxKeys.TO, info: TxInfo.TO },
  {
    label: TxLabels.INPUT_OUTPUT,
    key: TxKeys.INPUT_OUTPUT,
    info: TxInfo.INPUT_OUTPUT,
  },
];

export const txCChainImportExport: TransactionDetail[] = [
  ...txTypeImport,
  { label: TxLabels.FROM, key: TxKeys.FROM, info: TxInfo.FROM },
  { label: TxLabels.AMOUNT, key: TxKeys.CCHAIN_AMOUNT_EXPORT_TX, info: TxInfo.CCHAIN_AMOUNT_EXPORT_TX },
  { label: TxLabels.AMOUNT, key: TxKeys.CCHAIN_AMOUNT_IMPORT_TX, info: TxInfo.CCHAIN_AMOUNT_IMPORT_TX },
];

export const txTypeReward: TransactionDetail[] = [
  ...txDefault,
  { label: TxLabels.AMOUNT, key: TxKeys.AMOUNT, info: TxInfo.AMOUNT_REWARD_TX },
  { label: TxLabels.FEE, key: TxKeys.FEE, info: TxInfo.FEE },
];

export const txTypeBase: TransactionDetail[] = [
  ...txDefault,
  { label: TxLabels.AMOUNT, key: TxKeys.AMOUNT, info: TxInfo.AMOUNT_REWARD_TX },
  { label: TxLabels.FEE, key: TxKeys.FEE, info: TxInfo.FEE },
  { label: TxLabels.FROM, key: TxKeys.FROM, info: TxInfo.FROM },
  { label: TxLabels.TO, key: TxKeys.TO, info: TxInfo.TO },
  {
    label: TxLabels.INPUT_OUTPUT,
    key: TxKeys.INPUT_OUTPUT,
    info: TxInfo.INPUT_OUTPUT,
  },
];

export const txTypePermissionlessValidator = txTypeValidator;
export const txTypePermissionlessDelegator = txTypeDelegator;

export const getTransactionTypeArray = (
  transactionType: string,
): TransactionDetail[] => {
  switch (transactionType) {
    case TransactionType.IMPORT_TX:
      return txTypeImport;
    case TransactionType.EXPORT_TX:
      return txTypeExport;
    case TransactionType.ADD_VALIDATOR_TX:
      return txTypeValidator;
    case TransactionType.ADD_DELEGATOR_TX:
      return txTypeDelegator;
    case TransactionType.REWARD_TX:
      return txTypeReward;
    case TransactionType.ADD_PERMISSIONLESS_VALIDATOR_TX:
      return txTypePermissionlessValidator;
    case TransactionType.ADD_PERMISSIONLESS_DELEGATOR_TX:
      return txTypePermissionlessDelegator;
    case TransactionType.BASE_TX:
      return txTypeBase;
    default:
      return txDefault;
  }
};

export const getTransactionTypeAboutText = (type: string): string => {
  switch (type) {
    case TransactionType.IMPORT_TX:
      return "Assets were imported from UTXO Atomic Memory (sender c-chain)";
    case TransactionType.EXPORT_TX:
      return "Assets from p-chain were sent to UTXO Atomic Memory for enabling import to c-chain.";
    case TransactionType.ADD_VALIDATOR_TX:
      return "Validator added to p-chain network";
    case TransactionType.ADD_DELEGATOR_TX:
      return "Assets delegated to Validator";
    case TransactionType.ADVANCE_TIME_TX:
      return "Exact date and time sent to p-chain network.";
    case TransactionType.REWARD_TX:
      return "Reward transaction - Not used on Flare network.";
    case TransactionType.ADD_PERMISSIONLESS_VALIDATOR_TX:
      return "Validator added to p-chain network";
    case TransactionType.ADD_PERMISSIONLESS_DELEGATOR_TX:
      return "Assets delegated to validator";
    case TransactionType.BASE_TX:
      return "Assets transferred to another P-Chain account";
    case TransactionType.empty:
      return "";
    default:
      return "Unknown Transaction Type";
  }
};

export const transactionTypeLabels: Record<TransactionType, string> = {
  [TransactionType.IMPORT_TX]: "Import",
  [TransactionType.EXPORT_TX]: "Export",
  [TransactionType.ADD_VALIDATOR_TX]: "Add validator",
  [TransactionType.ADD_DELEGATOR_TX]: "Add delegator",
  [TransactionType.ADVANCE_TIME_TX]: "Advance time",
  [TransactionType.REWARD_TX]: "Reward",
  [TransactionType.ADD_PERMISSIONLESS_DELEGATOR_TX]: "Add permissionless delegator",
  [TransactionType.ADD_PERMISSIONLESS_VALIDATOR_TX]: "Add permissionless validator",
  [TransactionType.BASE_TX]: "Native transfer",
  [TransactionType.empty]: "",
};

export function getTransactionTypeLabel(type: TransactionType): string {
  return transactionTypeLabels[type] ?? "Error getting type";
}

export {};
